@if (title) {
  <h3>{{ title }}</h3>
}
@if (pages) {
  <div class="slider">
    @if (scrollLeft() > 0) {
      <svg (click)="navPrev()" class="nav-prev" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#F9F2EC"/>
        <path d="M 34,15.5 20.875,28.1346 34,40.7692" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    }
    <div class="items" #scroller>
      @for (page of pages; track page) {
        <div class="card item">
          @if (page.image) {
            <wagtail-page-element-image
              [image]="page.image"
              [width]="500"
              [sizes]="'(min-width: 1200px) 25vw, (min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw'"
              loading="lazy"
            ></wagtail-page-element-image>
          }
          <div class="card-body">
            @if (page.title) {
              <h5 class="card-title" aria-level="4">{{ page.title }}</h5>
            }
            @if (page.text) {
              <div class="card-text"><p>{{ page.text.substring(0, 80) }} ...</p></div>
            }
          </div>
          <div class="card-footer">
            <!-- TODO: *ngIf="page.link" -->
            <a href="{{ page.link | wagtailUrl }}" class="btn btn-black">Zum Thema</a>
          </div>
        </div>
      }
    </div>
    @if (totalWidth > scrollWidth && (scrollLeft() + scrollWidth) < totalWidth) {
      <svg (click)="navNext()" class="nav-next" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#F9F2EC" />
        <path d="M22 15.5L35.125 28.1346L22 40.7692" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
  </div>
}